export default __webpack_public_path__ + "static/media/ClosedEye.41c32b7d.svg";